/**
 *  httpClient.js
 *  @description: cliente que usan los componentes. Ya no llama a la API vieja
 *  (Koa): cada ruta la atiende el puente (core/bridge) contra la API v1 y
 *  regresa la misma forma de respuesta de antes.
 */
import { handle } from './bridge';

class Request {
   async get(url, data) {
      return handle('GET', url, data);
   }

   async post(url, data) {
      return handle('POST', url, data);
   }

   async put(url, data) {
      return handle('PUT', url, data);
   }

   async patch(url, data) {
      return handle('PATCH', url, data);
   }

   // postFile manda archivos y campos; files es un arreglo de File (o null)
   // en el orden en que el componente los adjuntaba (file_1, file_2…).
   async postFile(url, files, data) {
      return handle('POSTFILE', url, data, Array.isArray(files) ? files : []);
   }

   async delete(url, data) {
      return handle('DELETE', url, data);
   }
}

export default Request;
